<template>
  <v-dialog v-model="popup">
    <v-btn floating class="fixed" slot="activator">
      <v-icon>today</v-icon>
    </v-btn>
    <v-card>
      <v-expansion-panel>
        <v-expansion-panel-content
          v-for="(date, i) in dates" :key="i"
          :value="date.menu && popup">
          <div slot="header">{{ date.title }} {{ date.value }}</div>
          <v-card>
            <v-date-picker
              class="elevation-0"
              v-model="date.value"
              no-title>
            </v-date-picker>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-card-row actions>
        <v-btn
          block primary light
          @click.native.stop="emit">
          <v-icon class="mr-2" light>check</v-icon>
        </v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [null, null]
    }
  },
  data () {
    return {
      popup: false,
      dates: this.value
        .map((value, i) => ({
          value,
          title: this.$t(`dateintervalpicker.dates.${i}`),
          menu: false
        }))
    }
  },
  computed: {
    tr () {
      return {
        'night': 'jour',
        'nights': 'jours',
        'check-in': 'Du',
        'check-out': 'au',
        'day-names': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        'month-names': ['Jan', 'Fev', 'Mars', 'Avril', 'Mai', 'Juin', 'Juill', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
      }
    }
  },
  methods: {
    emit () {
      this.popup = false
      this.$emit('input', this.dates.map(x => x.value))
    }
  },
  mounted () {
    this.dates = this.dates
      .map((date, i) => ({
        ...date,
        menu: date.value && !(this.dates[i + 1] || {}).value
      }))
  }
}
</script>

<style scoped>
  .fixed { z-index: 1; }
  .picker { max-width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/DateIntervalPicker.vue